import { Skeleton } from "@/components/ui/skeleton";
import { useCredits } from "../queries/conversions.get.queries";
import { Card, CardHeader, CardDescription } from "@/components/ui/card";
import { ChartPie } from "lucide-react";

export default function CreditCounter() {
  const { data: credits, isPending } = useCredits();

  return (
    <div id="credit-counter">
      {isPending ? (
        <div className="flex items-center justify-center bg-card rounded-lg border md:shadow-md w-full p-3.5">
          <Skeleton className="h-8 w-full" />
        </div>
      ) : (
        <div>
          {credits === 0 ? (
            <div className="text-sm bg-card rounded-lg border md:shadow-md w-full p-3.5">
              Your first free conversion is complete! To set up an account to
              convert additional transcripts or any other assistance, feel free
              to connect with us at{" "}
              <a
                href={"mailto:support@transcriptgenie.com"}
                className="underline cursor-pointer"
              >
                support@transcriptgenie.com
              </a>
            </div>
          ) : (
            <Card className="px-1.5 py-0.5 rounded-lg">
              <CardHeader className="flex flex-row items-center justify-between p-3 pb-2">
                <CardDescription className="text-sm font-semibold text-sidebar-primary flex items-center gap-2">
                  <ChartPie className="size-4 text-primary" strokeWidth={2.5} />
                  Credits left
                </CardDescription>
                <CardDescription className="text-black text-sm">
                  <span className="font-bold">{credits}</span>
                </CardDescription>
              </CardHeader>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}
